import type { Building } from "@/types";

const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

export function BuildingPopup({ building }: { building: Building }) {
  return (
    <table>
      <tbody>
        <tr>
          <td>Year built</td>
          <td className="pl-2 text-right">{building.year_built}</td>
        </tr>
        <tr>
          <td>Avg. price/m²</td>
          <td className="pl-2 text-right">
            {numberFormatter.format(building.selling_price_per_meter)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
